import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return (
      data
        .map(
          (
            { action, is_required, event_execution, id, status, data },
            index
          ) => ({
            index,
            id,
            status,
            is_required,
            data: getActionExecutionData(action),
            action_execution_data: data,
            user_id: action?.event?.user_id,
            action_id: action.id,
            action_type: action?.type,
            event_type: action?.event?.type,
            trigger_type: action?.event?.trigger_type,
            event_value: action?.event?.data?.value_to,
            event_execution_id: event_execution.id,
            event_execution_data: event_execution.data,
          })
        )
        // ensure check requirements is displayed first
        .sort((a, b) => {
          let aIsCheckRequirements = a.action_type === 'check_requirements'
          let bIsCheckRequirements = b.action_type === 'check_requirements'

          if (aIsCheckRequirements && !bIsCheckRequirements) return -1
          if (!aIsCheckRequirements && bIsCheckRequirements) return 1
          return 0
        })
    )
  }, [data])
}

function getActionExecutionData({ type, data }) {
  switch (type) {
    case 'status_update':
      return {
        new_status: data.default_status ?? '',
        statuses: data.subset_statuses ?? [],
      }
    case 'task_insert':
      return {
        task: {
          title: data.title ?? '',
          description: data.description ?? '',
          document_template_id: data.document_template_id ?? null,
          generate_letter: false,
          assignee_id: null,
          task_basket_id: data.task_basket_id ?? null,
          recipient_id: null,
        },
      }
    case 'task_insert_new':
      return {
        new_task: {
          tags: data.tags ?? [],
          title: data.title ?? '',
          description: data.description ?? '',
          due_date: data.due_date ?? 'today',
          due_date_days: data.due_date_days ?? 0,
          assignee: data.assignee,
          board_id: data.board_id,
          priority: data.priority,
          stage_id: data.stage_id,
          actions: data.actions,
        },
      }
    case 'notification':
      return {
        notification: {
          recipient_id: null,
          email_templates: data.email_template.subset ?? [],
          sms_templates: data.sms_template.subset ?? [],
          email_template_id: data.email_template.default_value ?? null,
          sms_template_id: data.sms_template.default_value ?? null,
        },
      }
    case 'check_requirements':
      return data
    case 'create_procedure_receivables':
      return {
        claim: null,
        invoice: null,
      }
    default:
      return {}
  }
}
